// Match public_form_user_plus on the server. Unknown/missing roles must never
// become selectable simply because they are absent from a UI denylist.
const PUBLIC_FORM_RECIPIENT_ROLES = new Set(['user', 'admin', 'global admin']);

export const isEligiblePublicFormRecipient = (recipient) => {
  const id = Number(recipient?.id ?? recipient?.user_id);
  const accessLevel = recipient?.access_level;
  return Number.isSafeInteger(id)
    && id > 0
    && recipient?.eligible !== false
    && typeof accessLevel === 'string'
    && PUBLIC_FORM_RECIPIENT_ROLES.has(accessLevel.trim().toLowerCase());
};
